export const USER_PRESENCE_INTERVAL = 5000;

export const MAX_AVATAR_DISPLAY = 6;

export const MAX_TITLE_LENGTH = 100;
